import React from "react";

const Preloader = () => {
  return (
    <div className="progress pink darken-2">
      <div className="indeterminate"></div>
  </div>
 
  );
};

export default Preloader;
